/**
 * Utility functions for WhatsApp integration
 */
/**
 * Builds a WhatsApp URL from a phone number
 * @param phoneNumber - Phone number in format: country code + area code + number (e.g., "5511999999999")
 * @param message - Optional message to pre-fill
 * @returns WhatsApp URL (e.g., "https://wa.me/5511999999999?text=Hello")
 */
export function buildWhatsAppUrl(phoneNumber, message) {
    if (!phoneNumber) {
        return '';
    }
    // Remove any non-numeric characters (just in case)
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    if (!cleanNumber) {
        return '';
    }
    const baseUrl = `https://wa.me/${cleanNumber}`;
    if (message) {
        const encodedMessage = encodeURIComponent(message);
        return `${baseUrl}?text=${encodedMessage}`;
    }
    return baseUrl;
}
/**
 * Validates if a string is a valid WhatsApp phone number
 * @param phoneNumber - Phone number to validate
 * @returns true if valid, false otherwise
 */
export function isValidWhatsAppNumber(phoneNumber) {
    if (!phoneNumber) {
        return false;
    }
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    return cleanNumber.length >= 10 && cleanNumber.length <= 15;
}
//# sourceMappingURL=whatsapp.js.map